jQuery(document).ready(function ($) {
  // image alt
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\..+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
    if ($(this).hasClass('retina')) {
      $(this).attr('srcset', src + ' 2x').show();
    }
  });

  // breadcrumbs
  $('ul.breadcrumb').prepend('<li><a href="/">Home</a></li>');

  //View More for Directory
  $('.bio-content-toggle').click(function () {
    var $bio = $(this).parent();
    var $toggletext = $(this).children('.text');

    if ($bio.hasClass('expanded')) {
      $bio.removeClass('expanded');
      $toggletext.text("View More");
    } else {
      $bio.addClass('expanded');
      $toggletext.text("View Less");
    }
  });

  $('.main-content').on('click', '.provider-filters h3', function () {
    $(this).toggleClass('open');
    $(this).next('ul').toggleClass('open');
  });

  $('.main-content').on('click', '.listing-item .show-details', function () {
    $(this).parents('.listing-item').toggleClass("expanded");
    if ($(this).parents('.listing-item').hasClass('expanded')) {
      $(this).text('View Less');
    } else {
      $(this).text('View More Details');
    }
  });

  $('body').on('click', '.provider-filters span.fa-info', function (e) {
    e.stopPropagation();
    var content = $(this).parents('li').data('tooltip');

    $('.provider-info').attr('data-text', content);
    $('.provider-info').addClass('show-tip');
  });

  $('body').on('click', '.provider-info', function () {
    $('.provider-info').removeClass('show-tip');
  });

  $('.sidebar-content .ul1 li.placeholder').click(function () {
    var link = $(this);
    console.log('clicked');
    // if (typeof $(this).attr('href') === typeof undefined && $(this).attr('href') === false) {
    // $('.ul2', this).slideDown();
    $('.ul2', this).slideDown();
    // link.addClass('open');
    // }
  });

  // input mask
  $(':input').inputmask();

});

function jumpTo(providerId) {
  $(providerId).addClass('expanded');
  $('html, body').animate({
    scrollTop: $(providerId).offset().top - 150
  }, 2000);
}

function geolocFail() {
  alert("Geolocation is not supported by this browser.");
}


$('body').on('click', '.get-location', function () {

  if (navigator.geolocation) {
    var location_timeout = setTimeout(geolocFail, 10000);

    navigator.geolocation.getCurrentPosition(function (position) {
      clearTimeout(location_timeout);

      var lat = position.coords.latitude;
      var lng = position.coords.longitude;

      $('.hdn-location').val(lat + ',' + lng);
      $('#btnCheckCoords').click();
    }, function (error) {
      clearTimeout(location_timeout);
      geolocFail();
    });
  } else {
    // Fallback for no geolocation
    geolocFail();
  }





});


//Tables
$('#main').responsiveTables();